export default "__VITE_ASSET__8ODJ9$ID__"